import { RawRatingType } from "@/orders/entities";

export class RatingType {
  readonly id: string;
  readonly value: number;
  readonly description: string;

  constructor(data: RawRatingType) {
    this.id = data.id;
    this.value = data.value;
    this.description = data.description;
  }
}

export interface IRatingType {
  id: string;
  value: number;
  description: string;
  image?: string;
}
